export default {
  filesListWrapper: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  fileListItem: {
    padding: '16px',
    width: '100%',
    borderRadius: '16px',
    backgroundColor: (theme) => theme.palette.grays.lightestGray,
  },
  itemContentWrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
    minHeight: '120px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
  },
  itemFileWrapper: {
    width: '48px',
    minWidth: '48px',
    height: '48px',
    minHeight: '48px',
    borderRadius: '8px',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  itemImageWrapper: {
    cursor: 'zoom-in',
  },
  itemInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    color: (theme) => theme.palette.darkGray.main,
    overflowWrap: 'anywhere',
  },
  itemName: {
    fontSize: '1rem',
    fontWeight: '500',
    color: (theme) => theme.palette.grays.gray700,
  },
  itemLabel: {
    fontSize: '0.75rem',
    fontWeight: '700',
    color: (theme) => theme.palette.grays.gray400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  itemValue: {
    fontSize: '0.75rem',
    fontWeight: '500',
    color: (theme) => theme.palette.grays.gray400,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  icon: {
    fontSize: '18px',
    color: (theme) => theme.palette.grays.gray400,
  },
  imageContainer: {
    width: '48px',
    height: '48px',
    borderRadius: '8px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  },
  fileContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '38px',
    height: '38px',
    background: (theme) => theme.palette.grays.gray200,
    border: (theme) => `1px solid ${theme.palette.grays.gray400}`,
    borderRadius: '8px',
  },
};
